import { Component, HostListener, Input, OnInit } from '@angular/core';
import { ReferralPreRegistrationService } from '@mpt-fo/common/core/services/referral-pre-registration.service';

@Component({
	selector: 'app-joining-list-item',
	templateUrl: './joining-list-item.component.html',
	styleUrls: ['./joining-list-item.component.scss']
})
export class JoiningListItemComponent implements OnInit {
	platform = 'Android';
	isMobile = false;
	@Input() is404 = false;
	@Input() referralCode: string;
	readonly breakPoint = 900;
	@HostListener('window:resize', ['$event'])
	onResize(_event): void {
		this.setMobile(window.innerWidth);
	}

	constructor(private referralPreRegistrationService: ReferralPreRegistrationService) {

	}
	ngOnInit(): void {
		this.setMobile(window.innerWidth);
		this.platform = this.getPlatform();
	}

	setMobile(browserWidth) {
		this.isMobile = browserWidth <= this.breakPoint;
	}

	submitForm(){
		this.referralPreRegistrationService.openApplicationStore(this.referralCode);
	}

	getPlatform() {
		if (/Android/i.test(navigator.userAgent)) {
			return "Android";
		} else if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
			return "iOS";
		} else {
			return "Android";
		}
	}
}
